import Form from '@/common/components/Form/Form';

export default Form;
